export default [
	{
		path: "/curriculum-mapping",
		component: () => import("../views/CurriculumMapping/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/curriculum-mapping/node/:id/:action",
		component: () => import("../views/CurriculumMapping/Graph.vue")
	},
	{
		path: "/curriculum-mapping/learning-outcomes",
		component: () => import("../views/CurriculumMapping/LearningOutcomes/Home.vue")
	},
    {
		path: "/curriculum-mapping/learning-outcomes/report",
		component: () => import("../views/CurriculumMapping/LearningOutcomes/Report.vue")
	},
	{
		path: "/curriculum-mapping/learning-outcomes/unmapped",
		component: () => import("../views/CurriculumMapping/LearningOutcomes/ListUnmapped.vue")
	},
	{
		path: "/curriculum-mapping/learning-outcomes/group/add",
		component: () => import("../views/CurriculumMapping/LearningOutcomes/Group.vue"),
	},
	{
		path: "/curriculum-mapping/learning-outcomes/group/:group_id?",
		component: () => import("../views/CurriculumMapping/LearningOutcomes/Group.vue"),
	},
	{
		path: "/curriculum-mapping/learning-outcomes/edit/:id",
		component: () => import("../views/CurriculumMapping/LearningOutcomes/Edit.vue"),
	},
    {
		path: "/curriculum-mapping/components/",
		component: () => import("../views/CurriculumMapping/Components/Home.vue"),
	},
    {
		path: "/curriculum-mapping/components/add",
		component: () => import("../views/CurriculumMapping/Components/Edit.vue"),
	},
    {
		path: "/curriculum-mapping/components/:component_id?",
		component: () => import("../views/CurriculumMapping/Components/Edit.vue"),
	},
]
